module.exports = __webpack_public_path__ + "static/media/ministry_logo.d8e16fba.jpg";